import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class WareHouseStore {
  wareHouse = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      wareHouse: observable,
      total: observable,
      loading: observable,
      loadData: action,
      addData: action,
      getWareHouse: action,
      deleteRecord: action,
      addWarehouse: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit }) {
    var postData = { companyId: companyId, offset: offset, limit: limit };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=warehouse&a=warehouselist", "postData=" + base64Input);

    this.wareHouse = response?.data?.data?.warehousedata;

    this.total = parseInt(response?.data?.data?.TotalCount);
  }
  async addData(wareHouseDetails) {
    var postData = wareHouseDetails;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=warehouse&a=addwarehouse", "postData=" + base64Input);
    return response.data;
  }

  async deleteRecord({ warehouseId, companyId ,waslWarehouseKey,option}) {
    var postData = { warehouseId: warehouseId, companyId: companyId,option:option,waslWarehouseKey:waslWarehouseKey };
    const base64Input = await base64_encode(JSON.stringify(postData));
    console.log(postData)
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=warehouse&a=deletewarehouseNew",
        "postData=" + base64Input
      );
    return response;
  }
  async getWareHouse({ wid, companyId }) {
    var postData = { id: wid, companyId: companyId, limit: 1, offset: 0 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=warehouse&a=warehouselist", "postData=" + base64Input);

    return response?.data?.data?.warehousedata[0];
  }

  async addWarehouse(warehouse) {
    var postData = warehouse;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=wasl&a=registerWarehouse", "postData=" + base64Input);

    return response.data;
  }
}

export default WareHouseStore;
